<template>
  <v-container>
    <v-form :lazy-validation="true">
      <validation-observer ref="validationObserver" v-slot="{ invalid }">
        <v-row dense>
          <v-col>
            <validation-provider
              :name="$t('form.fields.teamName')"
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                outlined
                v-model="registration.teamName"
                :label="$t('form.fields.teamName') + ' *'"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider
              :name="$t('form.fields.university')"
              v-slot="{ errors }"
              rules="required"
            >
              <v-text-field
                outlined
                v-model="registration.university"
                :label="$t('form.fields.university') + ' *'"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" class="mt-n3">
            <span class="body-1 ml-1" v-html="$t('form.fields.professor')" />
            <v-divider />
          </v-col>
        </v-row>
        <v-row class="mb-2">
          <v-col cols="2" class="hidden-md-and-down">
            <v-select
              :label="$t('form.fields.salutation.label')"
              outlined
              v-model="registration.professorSalutation"
              :items="genderTypes"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('form.fields.firstname')"
              outlined
              v-model="registration.professorFirstName"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('form.fields.lastname')"
              outlined
              v-model="registration.professorLastName"
            />
          </v-col>
          <v-col cols="2" class="hidden-md-and-down">
            <v-text-field
              outlined
              v-model="registration.professorTitle"
              :label="$t('form.fields.title')"
            />
          </v-col>
        </v-row>
        <v-row class="mt-n8 mb-2">
          <v-col cols="6">
            <validation-provider
              :name="$t('form.fields.email')"
              v-slot="{ errors }"
              vid="originalEmailProfessor"
              rules="email|confirmed:@confirmationEmailProfessor"
            >
              <v-text-field
                v-model="registration.professorMail"
                :label="$t('form.fields.email')"
                outlined
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col cols="6">
            <validation-provider
              :name="$t('form.fields.emailConfirmation')"
              v-slot="{ errors }"
              vid="confirmationEmailProfessor"
              rules="email|confirmed:@originalEmailProfessor"
            >
              <v-text-field
                v-model="professorEmailConfirmation"
                :label="$t('form.fields.emailConfirmation')"
                outlined
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <div
          v-for="(participantField, index) in participantFields"
          :key="participantField.headline"
        >
          <v-row dense>
            <v-col cols="12" class="mt-n3">
              <span class="body-1 ml-1" v-html="participantField.headline" />
              <v-divider />
            </v-col>
          </v-row>
          <v-row class="hidden-lg-and-up mb-n6">
            <v-col>
              <validation-provider
                :name="$t('form.fields.salutation.label')"
                v-slot="{ errors }"
                rules="required"
              >
                <v-select
                  :label="$t('form.fields.salutation.label') + ' *'"
                  outlined
                  v-model="participantField.salutationObject"
                  :items="genderTypes"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
            <v-col>
              <v-text-field
                outlined
                v-model="participantField.titleObject"
                :label="$t('form.fields.title')"
              />
            </v-col>
          </v-row>
          <v-row class="mb-2">
            <v-col cols="2" class="hidden-md-and-down">
              <validation-provider
                :name="$t('form.fields.salutation.label')"
                v-slot="{ errors }"
                rules="required"
              >
                <v-select
                  :label="$t('form.fields.salutation.label') + ' *'"
                  outlined
                  v-model="participantField.salutationObject"
                  :items="genderTypes"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
            <v-col>
              <validation-provider
                :name="$t('form.fields.firstname')"
                v-slot="{ errors }"
                rules="required"
              >
                <v-text-field
                  :label="$t('form.fields.firstname') + ' *'"
                  outlined
                  v-model="participantField.firstNameObject"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
            <v-col>
              <validation-provider
                :name="$t('form.fields.lastname')"
                v-slot="{ errors }"
                rules="required"
              >
                <v-text-field
                  :label="$t('form.fields.lastname') + ' *'"
                  outlined
                  v-model="participantField.lastNameObject"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
            <v-col cols="2" class="hidden-md-and-down">
              <v-text-field
                outlined
                v-model="participantField.titleObject"
                :label="$t('form.fields.title')"
              />
            </v-col>
          </v-row>
          <v-row class="mt-n8 mb-4" dense v-if="index === 0">
            <v-col cols="12">
              <validation-provider
                :name="$t('form.fields.street')"
                v-slot="{ errors }"
                rules="required"
              >
                <v-text-field
                  :label="$t('form.fields.street') + ' *'"
                  outlined
                  v-model="registration.street"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
            <v-col cols="4" class="mt-n3">
              <validation-provider
                :name="$t('form.fields.zip')"
                v-slot="{ errors }"
                rules="required"
              >
                <v-text-field
                  :label="$t('form.fields.zip') + ' *'"
                  outlined
                  v-model="registration.zip"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
            <v-col cols="8" class="mt-n3">
              <validation-provider
                :name="$t('form.fields.city')"
                v-slot="{ errors }"
                rules="required"
              >
                <v-text-field
                  :label="$t('form.fields.city') + ' *'"
                  outlined
                  v-model="registration.city"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" class="mt-n3">
              <validation-provider
                :name="$t('form.fields.country')"
                v-slot="{ errors }"
                rules="required"
              >
                <v-autocomplete
                  :label="$t('form.fields.country') + ' *'"
                  outlined
                  :items="countries"
                  v-model="registration.country"
                  item-text="value"
                  item-value="key"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row class="mt-n8 mb-2">
            <v-col cols="6">
              <validation-provider
                :name="$t('form.fields.email')"
                v-slot="{ errors }"
                :vid="`originalEmail-${index}`"
                :rules="`required|email|confirmed:@confirmationEmail-${index}`"
              >
                <v-text-field
                  v-model="participantField.emailObject"
                  :label="$t('form.fields.email') + ' *'"
                  required
                  outlined
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
            <v-col cols="6">
              <validation-provider
                :name="$t('form.fields.emailConfirmation')"
                v-slot="{ errors }"
                :vid="`confirmationEmail-${index}`"
                :rules="`required|email|confirmed:@originalEmail-${index}`"
              >
                <v-text-field
                  v-model="participantField.emailConfirmationObject"
                  :label="$t('form.fields.emailConfirmation') + ' *'"
                  required
                  outlined
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row dense class="mt-n6">
            <v-col>
              <validation-provider
                :name="$t('form.fields.studyLevel.label')"
                v-slot="{ errors }"
                rules="required"
              >
                <v-select
                  :label="$t('form.fields.studyLevel.label') + ' *'"
                  outlined
                  v-model="participantField.studyLevelObject"
                  :items="studyLevels"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
            <v-col>
              <validation-provider
                :name="$t('form.fields.certificateOfStudy')"
                v-slot="{ errors }"
                rules="required"
              >
                <v-file-input
                  :label="$t('form.fields.certificateOfStudy') + ' *'"
                  outlined
                  :error-messages="errors"
                  v-model="participantField.certificateOfStudyObject"
                  :loading="submitting"
                  :accept="acceptingFormats"
                />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row dense class="mt-n2">
            <v-col>
              <validation-provider
                :name="$t('form.fields.birthyear')"
                v-slot="{ errors }"
                rules="required|numeric|length:4|min_value:1988"
              >
                <v-text-field
                  v-model="participantField.birthyearObject"
                  :label="$t('form.fields.birthyear') + ' *'"
                  required
                  outlined
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
            <v-col>
              <validation-provider
                :name="$t('form.fields.photo')"
                v-slot="{ errors }"
                rules="required"
              >
                <v-file-input
                  :label="$t('form.fields.photo') + ' *'"
                  outlined
                  :error-messages="errors"
                  v-model="participantField.photoObject"
                  :loading="submitting"
                  :accept="acceptingFormats"
                />
              </validation-provider>
            </v-col>
            <v-col>
              <validation-provider
                :name="$t('form.fields.shirtSize')"
                v-slot="{ errors }"
                rules="required"
              >
                <v-select
                  :label="$t('form.fields.shirtSize') + ' *'"
                  outlined
                  v-model="participantField.shirtSizeObject"
                  :items="shirtSizeValues"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </div>
        <v-row dense class="mt-n2">
          <v-col cols="12">
            <v-divider />
          </v-col>
          <v-col class="mt-6" cols="12">
            <v-textarea
              v-model="registration.notes"
              :label="$t('form.fields.notes')"
              outlined
            />
          </v-col>
          <v-col>
            <span
              class="body-1 ml-1 red--text font-weight-bold"
              v-html="$t('form.fields.rockbowlIdHint')"
            />
          </v-col>
        </v-row>
        <v-row class="ml-0 mb-6">
          <v-checkbox outlined v-model="agb">
            <span
              slot="label"
              v-html="
                $t('form.fields.rockbowlAgbs', { url: rulesPageUrl }) + ' *'
              "
            />
          </v-checkbox>
        </v-row>
        <v-row class="mb-n8" v-if="errorMessage">
          <v-col>
            <v-alert dense outlined type="error" v-html="errorMessage">
            </v-alert>
          </v-col>
        </v-row>
        <v-card-actions class="mt-3 mb-n5">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="invalid || !agb"
            @click="submit"
            :loading="submitting"
          >
            {{ $t("form.btn.register") }}
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-form>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="white--text headline primary" primary-title>
          {{ $t("confirmationDialog.title") }}
        </v-card-title>
        <v-card-text class="pa-md-4">
          {{ $t("confirmationDialog.confirmationTextRockbowl") }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="reload">
            {{ $t("confirmationDialog.buttonText") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { GenderTypes } from "../config/constants";
import {
  attachmentResource,
  rockbowlRegistrationResource,
  rockbowlRegistrationMailResource,
} from "../api/resources";
import de from "../i18n/de.json";
import Vue from "vue";

export default {
  data: () => ({
    registration: {
      teamName: "",
      university: "",
      street: "",
      zip: "",
      city: "",
      country: "",
      notes: "",
    },
    participantFields: [],
    professorEmailConfirmation: "",
    errorMessage: null,
    dialog: false,
    agb: false,
    submitting: false,
    rulesPageUrl: "",
    shirtSizeValues: ["XS", "S", "M", "L", "XL", "XXL"],
    acceptingFormats: ".gif,.jpg,.png,.pdf,.doc,.docx",
  }),
  created() {
    this.resetParticipantFields();
    this.rulesPageUrl = window.rockbowlRulesPageUrl;
  },
  methods: {
    async submit() {
      this.errorMessage = null;
      this.submitting = true;
      const toSubmit = { ...this.registration };

      for (let i = 0; i < this.participantFields.length; ++i) {
        const participantField = this.participantFields[i];
        toSubmit[`salutationParticipant${i}`] =
          participantField.salutationObject;
        toSubmit[`firstNameParticipant${i}`] = participantField.firstNameObject;
        toSubmit[`lastNameParticipant${i}`] = participantField.lastNameObject;
        toSubmit[`titleParticipant${i}`] = participantField.titleObject;
        toSubmit[`emailParticipant${i}`] = participantField.emailObject;
        toSubmit[`studyLevelParticipant${i}`] =
          participantField.studyLevelObject;
        toSubmit[`birthyearParticipant${i}`] = participantField.birthyearObject;
        toSubmit[`shirtSizeParticipant${i}`] = participantField.shirtSizeObject;
        let formData = new FormData();
        formData.append("file", participantField.certificateOfStudyObject);
        let data = await attachmentResource.post("", formData, {
          headers: { "x-xsrf-token": this.$cookies.get("oegg-cms.csrf") },
        });
        toSubmit[`certificateOfStudyAttachmentParticipant${i}`] = data.data;
        formData = new FormData();
        formData.append("file", participantField.photoObject);
        data = await attachmentResource.post("", formData, {
          headers: { "x-xsrf-token": this.$cookies.get("oegg-cms.csrf") },
        });
        toSubmit[`photoAttachmentParticipant${i}`] = data.data;
      }

      rockbowlRegistrationResource.post("", toSubmit);
      rockbowlRegistrationMailResource.post("", toSubmit, {
        headers: {
          "x-xsrf-token": Vue.$cookies.get("oegg-cms.csrf"),
        },
      });
      this.registration = {};
      this.agb = false;
      this.resetParticipantFields();
      this.$refs.validationObserver.reset();
      this.dialog = true;
      this.submitting = false;
    },
    reload() {
      location.reload();
    },
    resetParticipantFields() {
      const emptyEntry = {
        salutationObject: "",
        firstNameObject: "",
        lastNameObject: "",
        titleObject: "",
        emailObject: "",
        emailConfirmationObject: "",
        studyLevelObject: "",
        certificateOfStudyObject: null,
        birthyearObject: "",
        photoObject: null,
        shirtSizeObject: "",
      };
      this.participantFields = [
        {
          headline: this.$t("form.labels.contactLeader"),
          ...emptyEntry,
        },
        {
          headline: "Teamplayer 2",
          ...emptyEntry,
        },
        {
          headline: "Teamplayer 3",
          ...emptyEntry,
        },
      ];
    },
  },
  computed: {
    studyLevels() {
      return [
        {
          value: "undergraduate",
          text: this.$t("form.fields.studyLevel.undergraduate"),
        },
        {
          value: "masterGraduate",
          text: this.$t("form.fields.studyLevel.masterGraduate"),
        },
        {
          value: "phD",
          text: this.$t("form.fields.studyLevel.phD"),
        },
      ];
    },
    genderTypes() {
      return GenderTypes.map((t) => {
        return { value: t, text: this.$t(`form.fields.salutation.${t}`) };
      });
    },
    countries() {
      return Object.keys(de.countries).map((countryKey) => {
        return {
          key: countryKey,
          value: this.$t(`countries.${countryKey}`),
        };
      });
    },
  },
};
</script>
